export class TaxList {
  type: string;
  amount: number | undefined;
  constructor(item: Partial<TaxList>) {
    if (item.type == null)
      throw new Error(`Invalid list item in constructor: ${JSON.stringify(item)}
                type cannot be null`);

    this.type = item.type;
    this.amount = item.amount;
  }

  static createEmpty(): Partial<TaxList> {
    return new TaxList({
      type: '',
      amount: undefined,
    });
  }
}
